"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const listStyle = (0, app_1.css) `
  > * {
    display: block;
    + * {
      border-top: 0.0625rem solid ${(theme) => theme.stroke};
    }
  }
`;
const StyledList = app_1.styled.div `
  ${listStyle}
  > * {
    padding: ${(theme) => `${theme.spacing.small} ${theme.spacing.medium}`};
  }
`;
const StyledListWithPadding = app_1.styled.div `
  ${listStyle}
  padding: 0 ${(theme) => theme.spacing.medium};
  > * {
    padding: ${(theme) => theme.spacing.small} 0;
  }
`;
function List({ padding = 'inner', className, children, }) {
    const Render = padding === 'outer' ? StyledListWithPadding : StyledList;
    return (0, jsx_runtime_1.jsx)(Render, Object.assign({ className: className }, { children: children }));
}
exports.List = List;
